import React from 'react';
import styled from '@emotion/styled';
import MaterialTypography from '@material-ui/core/Typography';
import { mediaQuery } from '@styles/index';
import UN_ICONS_TYPOGRAPHY_VARIANT from 'types/unacademyIcons/typography.type';
import getTypographyVariant from '@utils/unacademyIcons/typographyHelper';

interface TypographyProps {
  color?: string;
  children: React.ReactNode;
  variant?: UN_ICONS_TYPOGRAPHY_VARIANT;
  fontSize?: string;
  fontWeight?: string;
  mobileMargin?: string;
  desktopMargin?: string;
  className?: string;
}
type TypographyType = {
  $color: string;
  $mobileSize: string;
  $desktopSize: string;
  $mobileWeight: string;
  $desktopWeight: string;
  $fontSize?: string;
  $fontWeight?: string;
  $mobileMargin?: string;
  $desktopMargin?: string;
};

const StyledTypography = styled(MaterialTypography)<TypographyType>`
  color: ${({ $color }) => $color};
  font-size: ${({ $desktopSize, $fontSize }) => $fontSize || $desktopSize};
  font-weight: ${({ $desktopWeight, $fontWeight }) =>
    $fontWeight || $desktopWeight};
  margin-bottom: ${({ $desktopMargin }) => $desktopMargin};
  &::selection {
    color: var(--color-i-all-black);
    background: var(--color-i-icon-light-tertiary);
  }
  ${mediaQuery.uptoMobile} {
    font-weight: ${({ $mobileWeight, $fontWeight }) =>
      $fontWeight || $mobileWeight};
    font-size: ${({ $mobileSize, $fontSize }) => $fontSize || $mobileSize};
    margin-bottom: ${({ $mobileMargin }) => $mobileMargin};
  }
`;

const Typography: React.FC<TypographyProps> = ({
  color,
  variant,
  fontSize,
  fontWeight,
  mobileMargin,
  desktopMargin,
  className,
  children
}) => {
  const { mobileSize, desktopSize, mobileWeight, desktopWeight } =
    getTypographyVariant(variant);
  return (
    <StyledTypography
      className={className}
      variant={variant}
      $mobileMargin={mobileMargin}
      $desktopMargin={desktopMargin}
      $mobileSize={mobileSize}
      $fontSize={fontSize}
      $fontWeight={fontWeight}
      $desktopSize={desktopSize}
      $mobileWeight={mobileWeight}
      $desktopWeight={desktopWeight}
      $color={color}
    >
      {children}
    </StyledTypography>
  );
};

Typography.displayName = 'Typography';

Typography.defaultProps = {
  color: 'var(--color-i-icon-light-tertiary)',
  variant: UN_ICONS_TYPOGRAPHY_VARIANT.H1,
  fontSize: null,
  fontWeight: null,
  mobileMargin: '8px',
  desktopMargin: '12px'
};

export default Typography;
